import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export class FormValidationUtils {
  static markAllFieldsAsTouched(form: FormGroup): void {
    Object.keys(form.controls).forEach(key => {
      form.get(key)?.markAsTouched();
    });
  }

  static getFormFieldError(form: FormGroup, fieldName: string, fieldLabels?: { [key: string]: string }): string | null {
    const field = form.get(fieldName);
    if (field?.invalid && (field.dirty || field.touched)) {
      if (field.errors?.['required']) {
        return `${FormValidationUtils.getFieldLabel(fieldName, fieldLabels)} is required`;
      }
      if (field.errors?.['maxlength']) {
        return `${FormValidationUtils.getFieldLabel(fieldName, fieldLabels)} is too long`;
      }
      if (field.errors?.['jsonObject']) {
        return `${FormValidationUtils.getFieldLabel(fieldName, fieldLabels)} must be a JSON object, e.g. {"key": "value"}`;
      }
    }
    return null;
  }

  /**
   * Empty string is valid; otherwise the value must parse as a plain JSON
   * object (not an array or scalar). Mirrors the server's 400 validation
   * for routine `arguments`.
   */
  static jsonObjectValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value ?? '').toString().trim();
    if (!value) {
      return null;
    }
    try {
      const parsed = JSON.parse(value);
      if (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return null;
      }
    } catch {
      // fall through to error
    }
    return { jsonObject: true };
  }

  private static getFieldLabel(fieldName: string, fieldLabels?: { [key: string]: string }): string {
    const defaultLabels: { [key: string]: string } = {
      name: 'Name',
      description: 'Description',
      runsAsId: 'Runs as User',
      workflowId: 'Workflow',
      versionId: 'Version',
      crontab: 'Schedule'
    };
    return fieldLabels?.[fieldName] || defaultLabels[fieldName] || fieldName;
  }
}

